// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"6f8fdc2d","512":"3152c97d","669":"e9a09e19","965":"dd3b4cd4"}[chunkId] + ".chunk.js";
};